/**
 * Generated bundle index. Do not edit.
 */

export * from './index';



// WEBPACK FOOTER //
// ../../../../../packages/platform-browser-dynamic/platform-browser-dynamic.ts